import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import Swal from 'sweetalert2'
import { Botijao } from "../types/Botijao";
import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default function usePostBotijao(onSuccess: () => void) {
  return useMutation((value: Botijao) =>
    api
      .post(URLS.BOTIJAO_API, value)
      .then((response) => {
        console.log(response);
        Swal.fire({
          title: "Botijão Cadastrado",
          text: "O botijão foi cadastrado com sucesso!",
          icon: "success",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#349946",
          allowOutsideClick: false
        }).then(() => {
          onSuccess();
          queryClient.invalidateQueries();
        });
      })
      .catch((err) => {
        console.log(err);
        err.response.status === 500 ?
          Swal.fire({
            title: `Erro de status ${err.response.status}`,
            text: `Ocorreu um erro interno ao cadastrar o botijão. Por favor, entre em contato com um administrador do sistema.`,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          })
        :
          Swal.fire({
            title: "Erro ao cadastrar o botijão",
            text: err.response.data.message,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          });
        }
      )
  )
}
